import emailValidator from 'email-validator';
import compareAsc from 'date-fns/compareAsc';
import parseISO from 'date-fns/parseISO';
import isValid from 'date-fns/isValid';
import React from 'react';

export const required = value => (value ? undefined : 'This field is required');

export const email = value =>
  value && !emailValidator.validate(value)
    ? 'Emails must have both an @ and domain (e.g. .com)'
    : undefined;

export const checkTime = values => {
  const errors = {};

  if (!values || !values.startTime || !values.endTime) {
    return errors;
  }

  try {
    // Safely parse strings to Date objects if necessary
    const start = typeof values.startTime === 'string' ? parseISO(values.startTime) : values.startTime;
    const end = typeof values.endTime === 'string' ? parseISO(values.endTime) : values.endTime;

    if (isValid(start) && isValid(end)) {
      if (compareAsc(start, end) === 1) {
        errors.endTime = 'End Time cannot be earlier than Start Time';
      }
    }
  } catch (error) {
  }

  return errors;
};

export const checkTemp = value =>
  value < 0 || value > 99 ? '2 digits or less' : undefined;

export const confirmEmail = (emailFieldValue, confirmEmailValue) =>
  emailFieldValue === confirmEmailValue
    ? undefined
    : 'validation.confirmNotEqual';

export const measurementRange = range => value =>
  (value && value !== '0.00' && parseFloat(value) < range[0]) ||
  (value && value !== '0.00' && parseFloat(value) > range[1])
    ? `Enter values between ${range[0]} and ${range[1]}`
    : undefined;

export const valueIsNumber = value =>
  value && isNaN(parseFloat(value))
    ? 'Please only use numbers and period. E.g. 100.0'
    : undefined;

export const maxLength = length => value =>
  value && value.length === length
    ? `Maximum ${length} characters.`
    : undefined;

export const composeValidators = (...validators) => (value, ...args) =>
  validators.reduce((error, validator) => error || validator(value, ...args), undefined);

export function passwordValid(password) {
  const errors = [];
  if (!password) {
    errors.push(<li key="req">Password is required.</li>);
  } else {
    if (password.length < 8) {
      errors.push(<li key="len">Password must be 8 or more characters.</li>);
    }
    if (!/([A-Z]+)/g.test(password)) {
      errors.push(<li key="up">Password must have at least 1 uppercase character.</li>);
    }
    if (!/([!@#$%^&*(),.?":{}|<>]+)/g.test(password)) {
      errors.push(<li key="spec">Password must have at least 1 special character.</li>);
    }
  }
  return errors.length >= 1 ? errors : undefined;
}

export function passwordsMatch({ password = '', passwordConfirmation = '' }) {
  const errors = {};
  if (password !== passwordConfirmation) {
    errors.passwordConfirmation = 'Your passwords do not match.';
    return errors;
  }
  return undefined;
}
